import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../config';

const ContractPage = () => {
  const { t, i18n } = useTranslation();
  const [contractText, setContractText] = useState('');
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const scrollBoxRef = useRef(null);

  const location = useLocation();
  const [bookingData, setBookingData] = useState(null);

  useEffect(() => {
    // Get passed data (bike, rental date, time, duration, finalPrice)
    if (location.state) {
      setBookingData(location.state);
    } else {
      // No data passed, redirect back
      alert(t('bike.bookingError', 'An error occurred. Please repeat the booking process.'));
      navigate('/explorer');
    }
  }, [location, navigate, t]);

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const res = await fetch(`${config.getApiUrl('contracts/bike_rental')}?lang=${i18n.language}`);
        const data = await res.json();
        if (data.success) {
          setContractText(data.text);
        }
      } catch (error) {
        console.error('Error fetching contract:', error);
      }
      setLoading(false);
    };

    fetchContract();
  }, [i18n.language]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setHasScrolledToBottom(true);
    }
  };

  const handleAccept = () => {
    navigate('/bikerental/checkout', {
      state: bookingData,
    });
  };
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">{t('contract.loading', 'Loading contract...')}</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-6 min-h-screen bg-gray-50">
      <div className="max-w-2xl w-full space-y-6">
        <h1 className="text-2xl font-bold text-center text-gray-800">
          {t('contract.title', 'Bike Rental Agreement')}
        </h1>

        <div
          ref={scrollBoxRef}
          onScroll={handleScroll}
          className="h-96 overflow-y-scroll p-4 border rounded-lg bg-white shadow-inner text-gray-700 whitespace-pre-line"
        >
          {contractText}
        </div>

        <button
          onClick={handleAccept}
          disabled={!hasScrolledToBottom}
          className={`w-full py-3 rounded-md text-white font-semibold transition ${
            hasScrolledToBottom
              ? 'bg-green-600 hover:bg-green-700'
              : 'bg-gray-400 cursor-not-allowed'
          }`}
        >
          {t('contract.acceptButton', 'I Accept')}
        </button>
      </div>
    </div>
  );
};

export default ContractPage;
